import s from '../allservices.jsx'

const getFriendService = actionCallback => {
    const accountId = localStorage.getItem("accountId")
    let token = "Token " + localStorage.getItem('token')
    fetch(s.get_friend + "/" + accountId + "/?Authorization=" + token, {
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    })
        .then(res => {
            if (res.status === 200 || res.status === 201 || res.status === 204 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            } else {
                res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getFriendService;


// WEBPACK FOOTER //
// ./src/services/components/get_friends.jsx